import { MarkerSeverity } from "./enums";
import mapStyles from "./mapStyles";

// Container for the overall map, currently set to fill the entire screen
export const containerStyle = { width: "100%", height: "calc(100vh - 48px)" };

// Coordinates for the default center location of the map
export const center = { lat: 20, lng: -4 };

// Decides the color for each type of marker, as it is represented inside the cluster icon
export const markerTypes = [
  { type: MarkerSeverity.Critical, color: "red" },
  { type: MarkerSeverity.Warning, color: "orange" },
  { type: MarkerSeverity.Normal, color: "green" },
];

export const libraries: any[] = ["places"];

export const getMapOptions = (style, position) => ({
  controlSize: 30,
  styles: mapStyles,
  disableDefaultUI: true,
  minZoom: 2,
  mapTypeId: "hybrid",
  mapTypeControl: true,
  mapTypeControlOptions: {
    style: style,
    position: position,
    mapTypeIds: ["roadmap", "hybrid"],
  },
  zoomControl: true,
  zoomControlOptions: {
    position: google.maps.ControlPosition.RIGHT_CENTER,
  },
  restriction: {
    latLngBounds: { north: 85, south: -85, west: -180, east: 180 },
    strictBounds: false,
  },
});
